let collapsibleContent = {
  init() {
      this.collapsibleContentSections = document.querySelectorAll('.collapsible-content-section');

      if (this.collapsibleContentSections.length) {
          for (const collapsibleContentSection of this.collapsibleContentSections) {
              let details = collapsibleContentSection.querySelectorAll('.collapsible-content details');
        
              if (details.length) {
                  for (const detail of details) {
                      detail.onclick = e => this.clickHandler(e, details);
                  }
              }
          }
      }
  },

  clickHandler(e, details) {
      if(window.screen.width > 989 && e.target.closest('.collapsible-content-section').classList.contains('footer__blocks-wrapper')) return
      
      let filteredDetails = [...details].filter(x => x != e.target.closest('details'));

      for (const detail of filteredDetails) {
          detail.open = false;
      }
  }
}

document.addEventListener('DOMContentLoaded', function () {
  collapsibleContent.init();
});